const previewRegex = /^deploy-preview-(\d+)--whoosh-staff.netlify.app$/;

export function getEnvironment() {
  const host = window.location.host;
  if (previewRegex.test(host)) {
    return {
      DEPLOY_ENV: "review",
      LAUNCH_DARKLY_CLIENT_SIDE_ID: "611427a38232090d6a29dad7",
      FULLSTORY_TOKEN: "16R7TJ",
    };
  }
  switch (host) {
    case "app.whoosh.io":
      return {
        DEPLOY_ENV: "prod",
        LAUNCH_DARKLY_CLIENT_SIDE_ID: "611423c70b5b603f161aeaac",
        FULLSTORY_TOKEN: "16R7TJ",
      };
    case "replica.whoosh.io":
      return {
        DEPLOY_ENV: "replica",
        LAUNCH_DARKLY_CLIENT_SIDE_ID: "611423c70b5b603f161aeaac",
        FULLSTORY_TOKEN: "16R7TJ",
      };
    case "qa.whoosh.io":
      return {
        DEPLOY_ENV: "qa",
        LAUNCH_DARKLY_CLIENT_SIDE_ID: "630fa14051ef5912161cf05d",
        FULLSTORY_TOKEN: "16R7TJ",
      };
    case "demo.whoosh.io":
      return {
        DEPLOY_ENV: "demo",
        LAUNCH_DARKLY_CLIENT_SIDE_ID: "6114270844cb563f30b95a16",
        FULLSTORY_TOKEN: "16R7TJ",
      };
    case "localhost:3000":
      return {
        DEPLOY_ENV: "local",
        LAUNCH_DARKLY_CLIENT_SIDE_ID: "6114272ab919584d0bd10bac",
        FULLSTORY_TOKEN: "16R7TJ",
      };
    default:
      return {
        DEPLOY_ENV: "dev",
        LAUNCH_DARKLY_CLIENT_SIDE_ID: "6114272ab919584d0bd10bac",
        FULLSTORY_TOKEN: "16R7TJ",
      };
  }
}

var apiHost: string;

export const getApiHost = async () => {
  if (!apiHost) {
    apiHost = await determineApiHost();
  }
  return apiHost;
};

export const getReviewApiHost = (feHost: string) => {
  if (previewRegex.test(feHost)) {
    const matches = feHost.match(previewRegex);
    const prNumber = matches![1];
    return `whoosh-pr-${prNumber}.gigalixirapp.com`;
  } else {
    return null;
  }
};

const determineApiHost = async () => {
  const host = window.location.host;
  const reviewApiHost = getReviewApiHost(host);

  if (host === "localhost:3000") {
    return "localhost:3000";
  } else if (reviewApiHost) {
    try {
      await fetch(`https://${reviewApiHost}/private/api`);
      return reviewApiHost;
    } catch (e) {
      return "api.dev.whoosh.io";
    }
  } else {
    return `api.${host}`;
  }
};
